export const templatesMixin = {
    inheritAttrs: false,
    computed: {
        busy: {
            get() {
                return this.$store.getters['seasonality/busy'];
            },
            set(newValue) {
                this.$store.commit('seasonality/setBusy', newValue);
            },
        },
        currentYear: {
            get() {
                return this.$store.getters['seasonality/currentYear'];
            },
            set(newValue) {
                this.$store.commit('seasonality/setCurrentYear', newValue);
            },
        },
        selectedTemplate: {
            get() {
                return this.$store.getters['seasonality/selectedTemplate'];
            },
            set(newValue) {
                this.$store.commit('seasonality/setSelectedTemplate', newValue);
            },
        },
        initialTemplate: {
            get() {
                return this.$store.getters['seasonality/initialTemplate'];
            },
            set(newValue) {
                this.$store.commit('seasonality/setInitialTemplate', newValue);
            },
        },        
        lastObject: {
            get() {
                return this.$store.getters['seasonality/lastObject'];
            },
            set(newValue) {
                this.$store.commit('seasonality/setLastObject', newValue);
            },
        },
        templates: {
            get() {
                return this.$store.getters['seasonality/templates'];
            },
        },
        defaultSeason: {
            get() {
                return this.$store.getters['seasonality/defaultSeason'];
            },
        },
        seasonsList: {
            get() {
                return this.$store.getters['seasonality/seasonsList'];
            },
        },
        properties: {
            get() {
                return this.$store.getters['seasonality/properties'];
            },
        },
        importTemplateFromPropertiesOptions: {
            get() {
                return this.$store.getters['seasonality/importTemplateFromPropertiesOptions'];
            },
        },
        templatesData: {
            get() {
                return this.$store.getters['seasonality/templatesData'];
            },
        },
        newSeasonObject: {
            get() {
                return this.$store.getters['seasonality/newSeasonObject'];
            },
        },
    },
    methods: {
        async fetchTemplates(setTemplate) {
            try {
                this.busy = true;
                await this.$store.dispatch('seasonality/fetchTemplates', setTemplate);
            } catch (e) {
                this.formattedErrorToast(e, 'Could not fetch templates list');
            } finally {
                this.busy = false;
            }
        },
        async fetchSeasonsList() {
            try {
                this.busy = true;
                await this.$store.dispatch('seasonality/fetchSeasonsList');
            } catch (e) {
                this.formattedErrorToast(e, 'Could not fetch seasons list');
            } finally {
                this.busy = false;
            }
        },
        async fetchPropertyTemplateSettings() {
            try {
                this.busy = true;
                await this.$store.dispatch('seasonality/fetchPropertyTemplateSettings');
            } catch (e) {
                this.formattedErrorToast(e, 'Could not fetch properties list');
            } finally {
                this.busy = false;
            }
        },
        async fetchTemplatesData() {
            try {
                this.busy = true;
                await this.$store.dispatch('seasonality/fetchTemplatesData');
            } catch (e) {
                this.formattedErrorToast(e, 'Could not fetch default data');
            } finally {
                this.busy = false;
            }
        },
        getWeeklyRatesPlaceholder(strip) {
            if (
                this.templatesData &&
                this.seasonsList &&
                this.templatesData.default_template_settings.use_weekly_rates &&
                this.defaultSeason.weekly_rate > 0
            ) {
                if (strip) {
                    return this.defaultSeason.weekly_rate + ' (Default)';
                } else {
                    return this.defaultSeason.weekly_rate;
                }
            }
            return 'N/A';
        },
        getMonthlyRatesPlaceholder(strip) {
            if (
                this.templatesData &&
                this.seasonsList &&
                this.templatesData.default_template_settings.use_monthly_rates &&
                this.defaultSeason.monthly_rate > 0
            ) {
                if (strip) {
                    return this.defaultSeason.monthly_rate + ' (Default)';
                } else {
                    return this.defaultSeason.monthly_rate;
                }
            }
            return 'N/A';
        },
    },
};
